// Mock API for development and testing

// Mock user login for testing
export const mockUserLogin = async (email: string, password: string) => {
  // Simulate network delay
  await new Promise(resolve => setTimeout(resolve, 500));

  // Mock user credentials for testing
  if (email === 'admin@localhost' && password === 'admin123') {
    return {
      success: true,
      user: {
        id: 'test-user-123',
        email: 'admin@localhost',
        firstname: 'Test',
        lastname: 'User',
        company: 'Test Company'
      }
    };
  }

  if (email === 'test@onzoe.com' && password === 'TestPassword123!') {
    return {
      success: true,
      user: {
        id: 'test-user-456',
        email: 'test@onzoe.com',
        firstname: 'Test',
        lastname: 'Customer',
        company: 'Test Company LLC'
      }
    };
  }

  throw new Error('Invalid credentials');
};

export const mockAdminLogin = async (email: string, password: string) => {
  // Simulate network delay
  await new Promise(resolve => setTimeout(resolve, 500));

  // Mock admin credentials
  if (email === 'admin@onzoe.com' && password === 'admin123') {
    return {
      success: true,
      admin: {
        id: '1',
        email: 'admin@onzoe.com',
        firstName: 'Admin',
        lastName: 'User',
        role: 'super_admin'
      }
    };
  }

  throw new Error('Invalid admin credentials');
};

export const mockAdminDashboard = async () => {
  // Simulate network delay
  await new Promise(resolve => setTimeout(resolve, 300));

  return {
    success: true,
    dashboard: {
      userStats: {
        total_users: 1250,
        new_users_30d: 89,
        active_users: 1100,
        active_users_7d: 892
      },
      agentStats: {
        total_agents: 2340,
        active_agents: 2100,
        voice_agents: 1800,
        text_chatbots: 340,
        custom_llms: 150,
        document_ai: 50
      },
      conversationStats: {
        total_conversations: 450000,
        conversations_today: 2400,
        avg_satisfaction: 4.7,
        total_leads_captured: 12500
      },
      subscriptionStats: {
        total_subscriptions: 1050,
        active_subscriptions: 980,
        monthly_revenue: 89500,
        churn_rate: 2.1
      },
      supportStats: {
        open_tickets: 23,
        resolved_today: 45,
        avg_response_time: 2.5,
        satisfaction_score: 4.6
      },
      recentActivities: [
        {
          id: '1',
          action: 'login',
          admin_user_id: '1',
          resource_type: 'admin',
          resource_id: '1',
          details: {},
          created_at: new Date(Date.now() - 300000).toISOString(),
          first_name: 'John',
          last_name: 'Doe'
        },
        {
          id: '2',
          action: 'user_updated',
          admin_user_id: '1',
          resource_type: 'user',
          resource_id: '100',
          details: {},
          created_at: new Date(Date.now() - 600000).toISOString(),
          first_name: 'Jane',
          last_name: 'Smith'
        }
      ]
    }
  };
};